<template>

<!--
<c:if test="${ _DEVICE_TYPE eq 'APP' }">
<script>
$(function() {
	$("#footer_wrap").remove();
})
</script>
</c:if> -->

<!-- <c:if test="${ _DEVICE_TYPE  ne 'APP' }"> -->

		<!-- 푸터 시작 -->
		<div id="footer_wrap">
			<!-- 푸터 영역 시작 -->
        <div class="addr_cont">
          <div class="container ">
            <img src="/images/common/logo_w.png" alt="대한변호사협회" title="대한변호사협회" class="logo_footer"/>

            <div class="address">
             TEL:02-2087-7881<br>
             Copyright 2016, KoreanBar Association
            </div>

            <div class="gotop" style="cursor: pointer; display: block;">
              <span>TOP</span>
            </div>
            <!-- //TOP  버튼 -->

          </div> <!-- //container -->
        </div>


				<!-- 모바일 버튼 시작 -->
					<!-- <div class="footer_moblie " onclick="go_desktop()">
						PC 버전으로 보기
					</div> -->
				<!-- 모바일 버튼 끝 -->


<!--
					<div class="footer_pc" onclick="go_desktop()">
						모바일 버전으로 보기
					</div>
-->
		</div> <!-- //footer_wrap -->






</template>


<script>
export default {
  mounted() {
    $(".gotop").hide();


    var speed = 100; // 스크롤속도
    $(".gotop").css("cursor", "pointer").click(function() {
        $('body, html').animate({scrollTop:0}, speed);
    });

    $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
            $('.gotop').fadeIn();
        } else {
            $('.gotop').fadeOut();
        }
    });
  },
  methods : {
    rel_toggle() {
      $('.rel_list').toggle();
    },
    goUrl(url, target) {
    //	location.href = url;

      if(target == '_blank') {
        window.open(url, '_blank');
      } else {
        window.open(url, '_self');
      }
    }

  },
}
</script>